import { render, staticRenderFns } from "./Sbpayerror.vue?vue&type=template&id=3cbf246f&"
import script from "./Sbpayerror.vue?vue&type=script&lang=js&"
export * from "./Sbpayerror.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports